import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    title: {
      mandatee: 'Upload the company’s draft statutes',
      nonMandate: 'Upload your company’s draft statutes',
    },
  },
  fr: {
    title: {
      mandatee: 'Ajoutez le projet de statuts',
      nonMandate: 'Ajoutez votre projet de statuts',
    },
  },
} as const);
